// extracted by mini-css-extract-plugin
export var container = "_gp-0";
export var content = "_gp-3";
export var customerTitle = "_gp-4";
export var empty = "_gp-5";
export var gray = "_gp-6";
export var header = "_gp-7";
export var info = "_gp-8";
export var loading = "_gp-2";
export var loadingCard = "_gp-9";
export var oneLine = "_gp-a";
export var personName = "_gp-e";
export var pillContainer = "_gp-b";
export var selected = "_gp-1";
export var text = "_gp-c";
export var twoLines = "_gp-d";
export var unread = "_gp-f";
export var unreadIndicator = "_gp-g";